import globals_br from "./br/globals";

const br_translation = {
  ...globals_br
};

export var br = br_translation;
